import { FC } from 'external/react'

import Package from 'context/package-context'
import Payment from 'context/payment-context'

import Admin from 'context/admin-context'
import Accounting from 'context/accounting-context'
import Public from 'context/public-context'
import Auth from 'context/auth-context'
import Parent from 'context/parent-context'

import { composeContext } from 'context/create'

const providersSets = {
    auth: [ Auth.Provider],
    public: [ Payment.Provider, Public.Provider],
    parent: [ Package.Provider, Payment.Provider, Public.Provider, Parent.Provider ],
    admin: [ Payment.Provider, Public.Provider, Admin.Provider ],
    accounting: [Payment.Provider, Public.Provider, Admin.Provider, Accounting.Provider]
}

type ProviderSetName = keyof typeof providersSets

const paramRoutes = {
  page:'/:pageName',
  offers: '/offers',
  offer: '/offers/:offerId',
  offerSubjects: '/subjects/:offerId/:idSelectCourse/:typeSubject',
  offerCourses: '/courses/:idSubject/:offerId/:idSelectCourse/:typeSubject',
  courseDetail:  '/course-detail/:courseId',
  summary: '/summary',
  home: '/home',
  parentPage: '/home/:pageName',
  support: '/home/support',
  packages: '/home/packages',
  package: '/home/packages/:packageId',
  users: '/home/users/:role',
  newUser: '/home/users/:role/new',
  userPackages: '/home/users/:role/packages/:userId',
  profile: '/home/profile',
  payment: '/home/payment',
  history: '/home/payment/history',
  admin: '/admin',
  adminOffers: '/admin/offers',
  adminOfferConfiguration: '/admin/offers/configuration/:offerId',
  adminClients: '/admin/clients',
  adminClient: '/admin/clients/:clientId',
  accounting: '/accounting',
  accountingPayouts: '/accounting/payouts',
  accountingPayout: '/accounting/payouts/:payoutId',
  accountingClients: '/accounting/clients',
  accountingClient: '/accounting/clients/:clientId',
}

export function withContext(Root:FC, name: ProviderSetName) {
    return composeContext(Root, providersSets[name], paramRoutes)
}

